<template>
    <v-dialog
        v-model="show"
        :title="$t('修改QQ号')"
        kind="modal"
        :status="status"
        :footer-config="footerConfig"
        class="modify-qq-dialog"
        @confirm="formSubmit"
        @cancel="close"
        @close="close"
    >
        <v-steps :index="setpIndex" :titles="titles" />
        <div
            class="modify-qq-desc"
        >
            <div v-if="setpIndex === 1">
                <div v-if="!verByMobile">
                    {{ $t('为了企点账号安全，请先验证当前管理员QQ账号') }}<br>
                    <template v-if="mobile">
                        <i18n-t path="若忘记QQ密码，请改用{useMobile}或{apply}以修改管理员QQ" tag="span">
                            <a slot="useMobile" @click="useMobile">{{ $t('手机验证') }}</a>
                            <a slot="apply" @click="submitApplication">{{ $t('提交申请表') }}</a>
                        </i18n-t>
                    </template>
                    <template v-else>
                        <i18n-t path="若忘记QQ密码，请{apply}以修改管理员QQ" tag="span">
                            <a slot="apply" @click="submitApplication">{{ $t('提交申请表') }}</a>
                        </i18n-t>
                    </template>
                </div>
                <div v-else>
                    {{ $t('为了企点账号安全，请先验证当前管理员手机号') }}<br>
                    <i18n-t path="若手机号无法使用，请{apply}来修改联系手机和管理员QQ" tag="span">
                        <a slot="apply" @click="submitApplication">{{ $t('提交申请表') }}</a>
                    </i18n-t>
                    <div class="modify-qq-desc-back">
                        <v-page-header
                            :back="{
                                title: $t('返回使用QQ密码验证'),
                                goBack: goBack,
                            }"
                        />
                    </div>
                </div>
            </div>
            <div v-else>
                <v-icon name="basic_warning_fill" remote size="20" :style="{color: '4A70FF'}" />
                {{ $t('请勿使用企点或企业QQ账号，否则会无法登录') }}
            </div>
        </div>
        <div class="body">
            <v-form
                v-if="verByMobile && setpIndex === 1"
                ref="changeQqForm"
                class="form"
                kind="desc"
                @submit.prevent="confirm"
            >
                <v-form-item
                    name="mobile"
                    error-placement="bottom-left"
                    :label="$t('手机号')"
                    :required="$t('请输入手机号')"
                >
                    <v-input
                        ref="internationalTelInput"
                        :value="form.mobile"
                        :width="354"
                        disabled
                        :clearable="false"
                        class="demo-default-input"
                        :placeholder="$t('请输入手机号')"
                        autofocus
                    />
                </v-form-item>
                <v-form-item
                    :rules="formRules.sms_code"
                    name="sms_code"
                    error-placement="bottom-left"
                    :label="$t('验证码')"
                    :required="$t('请输入验证码')"
                >
                    <div
                        class="input_sms_code"
                    >
                        <v-input
                            v-model="form.sms_code"
                            :width="244"
                            name="sms_code"
                        />
                    <v-button
                        :disabled="isCountdown || !form.mobile"
                        :loading="sendCaptchaLoading"
                        class="captch-btn"
                        @click="sendCaptcha"
                    >
                        {{ isCountdown ? $t('{n}s', { n: countdown }) : $t('获取验证码') }}
                    </v-button>
                    </div>
                </v-form-item>
            </v-form>
            <div v-else-if="setpIndex === 1">
                <div class="ptlogin">
                    <iframe width="452px" height="100%" frameborder="0" scrolling="no" :src="'' + QQPubAccPTLoginFrameSrc + ''" style="width: 452px; height: 376px; visibility: visible;" />
                </div>
            </div>
            <div v-else-if="setpIndex === 2">
                <div class="ptlogin-new">
                    <iframe width="452px" height="100%" frameborder="0" scrolling="no" :src="'' + QQPubAccPTLoginFrameSrcNew + ''" style="width: 452px; height: 376px; visibility: visible;" />
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>

const CHECK_MSG_URL = '/mng/account/contacts/checkVerifySMS';
const GET_CAPTCHA = '/mng/account/contacts/sendVerifySMS';
const DEFAULT_FORM = {
    mobile: '',
    sms_code: '',
};
const COUNT_DOWN_INIT = 60;
const LOCATION_ORIGIN = window.location.origin ? window.location.origin : `${window.location.protocol}//${window.location.hostname}`;
const proxyUrl = encodeURIComponent(`${window.location.protocol}//${window.location.host}/static_proxy/qidian/src/comp/login/proxy.html`);

import { getCurrentLocale } from '@/utils/locale-reader';
const langParam = getCurrentLocale() === 'en-US' ? '&lang=1033' : '';

// 验证原qq iframe
const miBaoCgi = `${LOCATION_ORIGIN}/` + 'mng/account/contacts/verifyOldQQ';
const PT_LOGIN_URL = 'https://xui.ptlogin2.qq.com/cgi-bin/xlogin?cb=JSON_CB_20150313&appid=1600001230'
    + `&s_url=${miBaoCgi}&proxy_url=${proxyUrl}&border_radius=1&enable_qlogin=0&hide_close_icon=1&target=self${langParam}`;

// 新qq iframe
const miBaoCgiNew = `${LOCATION_ORIGIN}/` + 'mng/account/contacts/verifyNewQQ';
const newPtLogin = 'https://xui.ptlogin2.qq.com/cgi-bin/xlogin?cb=JSON_CB_20150313&appid=1600001230'
    + `&s_url=${miBaoCgiNew}&proxy_url=${proxyUrl}&border_radius=1&enable_qlogin=0&hide_close_icon=1&target=self${langParam}`;

export default {
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        mobile: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            titles: [this.$t('账号验证'), this.$t('修改QQ号')],
            show: false,
            aidList: [],
            filterAidList: [],
            form: {
                ...DEFAULT_FORM,
                mobile: this.mobile,
            },
            step: 0,
            bindLoading: false,
            bindStatusLoading: false,
            countdown: COUNT_DOWN_INIT,
            hasBindAccount: '',
            countdownTimer: null,
            sendCaptchaLoading: false,
            verPreMobSuc: false,
            formRules: {
                mobile: [
                    {
                        require: true,
                        message: this.$t('手机号不能为空'),
                        trigger: 'submit',
                    },
                    {
                        validate(value) {
                            return /^1(?:\d){10}$/.test(value);
                        },
                        message: this.$t('手机号格式不正确'),
                        trigger: 'change',
                    },
                    {
                        validate(value) {
                            return /^1(?:\d){10}$/.test(value);
                        },
                        message: this.$t('手机号格式不正确'),
                        trigger: 'submit',
                    },
                ],
                sms_code: [
                    {
                        required: true,
                        message: this.$t('验证码不能为空'),
                        trigger: 'submit',
                        trim: false,
                    },
                    {
                        validate(value) {
                            return /^\d{6}$/.test(value);
                        },
                        message: this.$t('验证码格式错误'),
                        trigger: 'submit',
                    },
                ],
            },
            verByMobile: false,
            setpIndex: 1,
            QQPubAccPTLoginFrameSrc: PT_LOGIN_URL,
            QQPubAccPTLoginFrameSrcNew: newPtLogin,
        };
    },
    computed: {
        status() {
            if (this.setpIndex === 1 && this.verByMobile) {
                return '';
            }
            return 'default';
        },
        isCountdown() {
            return this.countdown < COUNT_DOWN_INIT;
        },
        footerConfig() {
            return {
                primary: {
                    kind: 'primary',
                    text: this.confirmText,
                },
                cancel: {
                    kind: 'default',
                    text: this.$t('取消'),
                },
            };
        },
        confirmText() {
            if (this.setpIndex === 1) {
                return this.$t('下一步');
            }
                return '';
        },
    },
    watch: {
        showDialog: {
            handler(newVal) {
                this.form.mobile = this.mobile;
                this.verByMobile = false;
                this.show = newVal;
                this.setpIndex = 1;
            },
            deep: true,
        },
    },
    created() {
        this.form.mobile = this.mobile;
    },
    mounted() {
        window.cb_login_success = (result) => {
            this.OnOldQQPubPTLoginSuccess(result);
        };
        window.veri_newQQ_success = (result) => {
            this.OnVeriNewQQSuccess(result);
        };
    },
    methods: {
        OnOldQQPubPTLoginSuccess(res) {
            if (res && res.r === 0) {
                this.setpIndex = 2;
            } else if (res.r === 50004) {
                this.$message.error(this.$t('请输入管理员QQ进行验证'));
                this.close();
            } else {
                this.$message.error(res.errMsg || this.$t('出错了'));
                this.close();
            }
        },
        OnVeriNewQQSuccess(res) {
            if (res && res.r === 0) {
                if (res.isLogout) {
                    this.$message.success(this.$t('修改管理员帐号成功！您需要再次登陆'));
                } else {
                    this.$message.success(this.$t('修改管理员帐号成功!'));
                }
                this.close();
                this.$emit('on-bind-success');
            } else {
                this.$message.error(res.errMsg || this.$t('出错了'));
                this.close();
            }
        },
        submitApplication() {
            this.close();
            this.$emit('openApplication', 1);
        },
        useMobile() {
            this.verByMobile = true;
        },
        goBack() {
            this.verByMobile = false;
        },
        close() {
            this.$emit('close');
        },
        startCountdown() {
            /* eslint-disable no-plusplus */
            this.countdown--;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= -1) {
                    this.clearCountdownTimer();
                    this.countdown = COUNT_DOWN_INIT;
                }
            }, 1000);
        },
        clearCountdownTimer() {
            clearInterval(this.countdownTimer);
        },
        sendCaptcha() {
            // 如果手机号码不合法，则不能获取验证码
            if (!/^1(?:\d){10}$/.test(this.form.mobile)) {
                return;
            }
            this.sendCaptchaLoading = true;
            const form = {
                mobilePhoneNum: this.form.mobile,
            };
            this.$ajax.post(GET_CAPTCHA, form)
                .then(() => {
                    this.startCountdown();
                    this.sendCaptchaLoading = false;
                });
        },
        confirm() {
            this.checkoutPreMobile();
        },
        formSubmit(e) {
            e.preventDefault();
            if (this.setpIndex === 1 && this.verByMobile) this.$refs.changeQqForm.submit();
        },
        checkoutPreMobile() {
            this.bindLoading = true;
                this.$ajax.post(CHECK_MSG_URL, { mobilePhoneNum: this.form.mobile, SMSCode: this.form.sms_code })
                    .then(() => {
                            this.$message.success(this.$t('手机验证成功'));
                            this.bindLoading = false;
                            this.form.mobile = '';
                            this.form.sms_code = '';
                            this.clearCountdownTimer();
                            this.countdown = COUNT_DOWN_INIT;
                            this.setpIndex = 2;
                        });
        },
        resetForm() {
            this.form = {
                ...DEFAULT_FORM,
                mobile: this.mobile,
            };
            this.clearCountdownTimer();
            this.countdown = COUNT_DOWN_INIT;
            this.hasBindAccount = '';
            this.step = 0;
        },
    },
};
</script>

<style lang="less">
.modify-qq {

    &-dialog {
        .v-dialog__content {
            width: 500px;
        }

        .ptlogin {
            margin-bottom: 24px;
        }

        .ptlogin-new {
            margin-bottom: 24px;
        }

        .tip-box {
            &-description {
                font-size: 16px;
                font-weight: 500;

                &-text {
                    margin-top: 20px;
                }

                .icon {
                    &-warning {
                        fill: #f75559;
                        transform: rotate(180deg);
                    }

                    &-primary {
                        fill: #4A70ff;
                    }

                    &-success {
                        fill: #0fb87f;
                    }
                }
            }
        }

        .input_sms_code {
            height: 32px;
            align-items: baseline;
            width: 354px;
            vertical-align: baseline;
            display: inline-flex;
            flex-direction: row;
            justify-content: space-between;
        }

        .captch-btn {
            min-width: 102px;
        }
    }
    &-desc {
        display: inline-block;
        width: 100%;
        margin: 8px 0;
        color: rgba(1, 11, 50, 0.41);
        text-align: left;

        .v-icon {
            vertical-align: -4px;
        }

        a {
            cursor: pointer;
        }
    }
}
</style>
